export default __webpack_public_path__ + "static/media/myMovies.448e46a0.gif";